import { Link } from 'components/navigation/Link/Link';
import './AlertActionCard.scss';
import OText from 'components/CText/OText';

const AlertActionCard = props => {
  const {
    icon,
    description,
    ctaText,
    ctaLink,
    detailsLinkClick,
    detailsPageName,
    datatestid,
  } = props || {};

  return (
    <div className="alertActionCard pad16 border-rad4px grayShadow text-center margB16">
      {icon && <div className="actionIcon padtb8">{icon}</div>}
      <div
        className="padtb8 text-14 bold"
        data-testid={`${datatestid}-description`}
      >
        <OText text={description} />
      </div>
      {ctaText && (
        <Link
          to={ctaLink}
          onClickCallback={detailsLinkClick}
          clickType={ctaText}
          detailsPageName={detailsPageName}
          className={
            'mrphbutton STDpat01 secondary_cta_bg_light border-rad100px format50 m-format100 margT16 text-14'
          }
          datatestid={`${datatestid}-link`}
        >
          {ctaText}
        </Link>
      )}
    </div>
  );
};

export default AlertActionCard;
